var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "image-alt-text",
    severity: _rule2.default.Severity.BULK_WARNING,
    selector: "image",
    lint: function lint(state, content, nodes, match) {
        var image = nodes[0];
        if (!image.alt || !image.alt.trim()) {
            return "Images should have alt text:\nfor accessibility, all images should have alt text.\nSpecify alt text inside square brackets after the !.";
        } else if (image.alt.length < 8) {
            return "Images should have alt text:\nfor accessibility, all images should have descriptive alt text.\nThis image's alt text is only " + image.alt.length + " characters long.";
        }
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/image-alt-text.js
 ** module id = 218
 ** module chunks = 0 2
 **/